
namespace RioERP.Orders {
    export class CounterOrdersColumns {
        static columnsKey = 'Orders.CounterOrders';
    }
}